<template>
    <div class="pmtdiv">
        <smallbutton :toplabel="name" @click="startAdd()" v-if="showButton" :buttonclass="buttonClass" :disabled="disabled"/>
        <linkbutton :toplabel="name" @click="startAdd()" v-if="!showButton"/>
        <!--  MODAL -->
          <actionmodal ref="mymodal"  > 
            <template v-slot:body>
                
                    <label class="titlelabel">{{name}}</label>
                    <br/>
                    
                    <div class="horizFlex">
                        <div class="entry">    
                            <div class="entryTextDiv">
                                <label class="entryLabel" for="">Gift Card Number</label>
                                <label class="required"></label>
                            </div>
                            <input ref="cardnum" class="entryText "  name=""   v-model="numberData"
                                @keyup.enter="getbalance()">
                            
                        </div>
                        <button type="button"  @click="getbalance()"  class="balbutton" >Balance</button>
                    </div>
                    <div class="rightjustified">
                        <label class="ballabel">Balance: ${{giftBalance}}</label>
                    </div>
                        <div>
                            <smallbutton  @click="close()" toplabel="Close"/>
                        </div>
                    
                    <div>
                        <label class="responsemessage">{{responseMessage}}</label>
                    </div>
                    
                
                
                
            </template>
          </actionmodal>
        </div>
    </template>
    
    <script>
    import {mapFields} from 'vuex-map-fields'
    import format from '../../style/format.js'
    import smallbutton from '../controls/button.vue'
    import linkbutton from '../controls/linkbutton.vue'
    import actionmodal from '../controls/actionmodal.vue'
    import formentry from '../controls/entry.vue'
    import datamethods from '../../services/datamethods.js'
    export default {
        name:'giftcardbalance',
        components:{
            smallbutton,
            actionmodal,
            formentry,
            linkbutton
        },
        props:{
           
            showButton:{
                type:Boolean,
                default:true
            },
            name:{
                type:String,
                default:'Gift Card Balance'
            },
            defaultAmount:{
                type:Number,
            },
            numberDataLabel:{
                type:String,
                default:''
            },
            buttonClass:{
                type:String,
                default:'button buttonpay'
            },
        disabled:{
            type:Boolean,
            default:false
        }
            
        },
        mixins:[format,datamethods],
        data(){
            return{
                
                numberData:null,
                giftBalance:0
                
            }
        },
        computed:{
            ...mapFields([
                'responseMessage',
                'pleaseWait'
            ]),
 
        },
        methods:{
            close(){
                this.responseMessage=null
                this.$refs.mymodal.closeModal()
            },
            startAdd(){
                this.numberData=null
                this.responseMessage=null
                this.giftBalance=0
                this.$refs.mymodal.openModal()
                this.$nextTick(() => {
                    this.$refs.cardnum.focus();
                    })
            },
           
            async getbalance(){
                if (this.numberData=='' || this.numberData==null){return}
                let req = {
                    CardNumber:this.numberData
                }
                //call api
               // this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'giftcardbalance')
                //handle response
            
                if(response.Successful){
                    this.giftBalance=response.StringResponse;
                    
                }else{
                    this.responseMessage = response.Message
                }
               // this.pleaseWait=false;
            }
        }
    }
    </script>
    
    <style>
    .balbutton{
        height:25px;
        background-color:var(--button-color);
        color:var(--light-text-color);
        border:none;
        border-radius:2px;
        padding:5px;
        margin-top:5px;
    }
    .ballabel{
        margin-left:32px;
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    